import * as App from '../../app';
import bridge from '@vkontakte/vk-bridge';
import { randomItem } from '../../lib/utils';
import { WALL_POSTS } from '../storage';
export function wallPost(cb) {
    if (FOR_VK) {
        var slogans = [
            '"Судоку Пазл" это головоломка представляющая собой смесь "Тетриса" и "Судоку" или "Тетрис" без спешки на поле как в "Судоку".',
            // 'Квадратиш. Практиш. Гут!',
        ];
        var message = randomItem(slogans);
        var messageIndex_1 = slogans.indexOf(message);
        wallPostStat("start-".concat(messageIndex_1));
        // https://dev.vk.com/sdk/mobile#showShareBox
        // https://dev.vk.com/bridge/VKWebAppShowWallPostBox
        // https://dev.vk.com/method/wall.post
        bridge
            .send('VKWebAppShowWallPostBox', { message: message, attachments: 'https://vk.com/app8151701' })
            // TODO тут нужно передавать ИД и можно прицепить картинку
            // TODO https://dev.vk.com/api/app-run-parameters (referrer, hash)
            // .send('VKWebAppShowWallPostBox', {message, attachments: 'https://papergame.ru/tudoku/api/game?id=0'})
            .then(function (data) {
            var success = data && data.post_id !== undefined;
            addPostType(WALL_POSTS.GAME__INFO, success);
            cb && cb(success);
            wallPostStat("".concat(success ? 'ok' : 'error', "-").concat(messageIndex_1));
        })
            .catch(function (_err) {
            // Отказ от публикации
            addPostType(WALL_POSTS.GAME__INFO, false);
            cb && cb(false);
            wallPostStat("cancel-".concat(messageIndex_1));
        });
    }
}
function wallPostStat(key) {
    var _a;
    App.stat.params({ wallPost: (_a = {}, _a[key] = 1, _a) });
}
export function addPostType(type, where) {
    var wallPostStatus = App.storage.get().wallPostStatus;
    wallPostStatus = !(wallPostStatus & type) && where ? wallPostStatus + type : wallPostStatus;
    App.storage.upd({ wallPostStatus: wallPostStatus, wallPostTime: Date.now() });
    if (FOR_VK)
        App.Fn.vkWebAppStorageSet('wallPostStatus', wallPostStatus);
}
export function checkPostType(type, countHours) {
    var msInOneHour = 1000 * 60 * 60;
    var _a = App.storage.get(), wallPostStatus = _a.wallPostStatus, wallPostTime = _a.wallPostTime;
    return !(wallPostStatus & type) && Date.now() - wallPostTime > countHours * msInOneHour;
}
